export class Step1 {
    constructor() {}
    intitule = 'stepper.form.mapa_re.step1';
    getspan1 = 'form.mapa_re.getspan1';
    getidweb = 'form.mapa_re.getidweb';
    getdatepublication = 'form.mapa_re.getdatepublication';

}
